import React, {useEffect, useState} from "react";
import {doesEmailRespectPattern} from "../../../../utils/BubblyUtils";
import {buildCSSFormGroupInput} from "../../../../utils/BubblyUIUtils";
import {Link, withRouter} from "react-router-dom";
import {withToastManager} from "react-toast-notifications";
import AuthenticationService from "../../../../services/Authentication/AuthenticationService";
import LoadingIndicator from "../../../meta/LoadingIndicator";

function PasswordResetEmail(props) {
    const [userEmail, updateUserEmail] = useState("");
    const [userEmailValid, updateUserEmailValid] = useState(undefined);
    const [passwordResetting, updatePasswordResetting] = useState(undefined);

    useEffect(() => {
        if (props.hashVerificationFailed) {
            props.toastManager.add("The link has expired. Please try again.", {
                appearance: 'error'
            });
        }
    }, []);

    function onEmailChange(event){
        const email = event.target.value;
        if(email.includes(" ")) {
            return;
        }
        updateUserEmail(email);
        if (doesEmailRespectPattern(email)) {
            AuthenticationService.checkIfEmailIsValid(email,
                (success) => {
                    const emailIsInDatabase = !success.data;
                    updateUserEmailValid(emailIsInDatabase);
                    buildCSSFormGroupInput(event, "passwordResetEmailFormGroup", "passwordResetEmailFormGroupError", emailIsInDatabase);
                },
                (error) => {
                    updateUserEmailValid(false);
                    buildCSSFormGroupInput(event, "passwordResetEmailFormGroup", "passwordResetEmailFormGroupError", false);
                }
            );
        } else {
            updateUserEmailValid(false);
            buildCSSFormGroupInput(event, "passwordResetEmailFormGroup", "passwordResetEmailFormGroupError", false);
        }
    }

    function onPasswordResetAction(event) {
        event.preventDefault();
        updatePasswordResetting(true);
        AuthenticationService.sendPasswordResetEmail(userEmail, props.handleFinishSubmit,
            (success) => {
                updatePasswordResetting(false);
            },
            (error) => {
                updatePasswordResetting(false);
                props.toastManager.add("An error has occurred!", {
                    appearance: 'error'
                });
            }
        );
    }

    return (
        <div className="container">
            <h1 className="pt-md pb-xl">Reset your password</h1>
            <p className="color--darkgray pb-xl text-center">Enter the email you’re using for your account.</p>
            <form action="" className="form pt-sm" onSubmit={onPasswordResetAction}>
                <div className="form__group" id="passwordResetEmailFormGroup">
                    <div className="form__group__input">
                        <input className="form__group__input__text" type="email" placeholder="janedoe@email.com" value={userEmail} onChange={onEmailChange} disabled={passwordResetting}/>
                        <span className="form__group__input__icon">
                            <img src="./assets/img/login_page/mail.png" alt=""/>
                        </span>
                        <span className="form__group__input_check" style={{opacity: userEmailValid ? 100 : 0}}>
                            <img src="./assets/img/login_page/icon-check--green.png" alt=""/>
                        </span>
                    </div>
                    <span className="form__group__error form__group__error--email" id="passwordResetEmailFormGroupError">Please enter a valid email address</span>
                </div>
                {
                    passwordResetting && <LoadingIndicator/>
                }
                {
                    !passwordResetting &&
                    (
                        <div className="cta__wrapp pv-xs">
                            <input type="submit"
                                   id="passwordResetSubmit"
                                   className={userEmailValid ? "cta--normal cta--fullwidth cta--notransform" : "cta--normal cta--fullwidth cta--notransform cta--soft-disabled"}
                                   disabled={!userEmailValid}
                                   value={"Send instructions"}/>
                        </div>
                    )
                }
                <div className="cta__wrapp pv-xs">
                    <Link to="/login" className="cta--text cta--notransform">Back to log in</Link>
                </div>
            </form>
        </div>
    )
}

export default withRouter(withToastManager(PasswordResetEmail));
